var map = {
	"./back.png": 5409,
	"./close.png": 6348,
	"./copy.png": 3910,
	"./danger.png": 7380,
	"./deposit.png": 8933,
	"./edit.png": 3873,
	"./error.png": 4184,
	"./game.png": 830,
	"./home.png": 1552,
	"./info.png": 7509,
	"./kyc_pending.png": 9544,
	"./kyc_success.png": 9284,
	"./promo.png": 3568,
	"./refresh.png": 5938,
	"./save.png": 3675,
	"./send.png": 6794,
	"./star.png": 8134,
	"./star_fill.png": 7924,
	"./success.png": 1362,
	"./wallet.png": 2267,
	"./warning.png": 2293,
	"./withdraw.png": 8850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;